import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DropdownModule, CalendarModule, CheckboxModule, AutoCompleteModule, GrowlModule } from 'primeng/primeng';
import { TableModule } from 'primeng/table';

import { DownloadRoutingModule } from './download-routing.module';
import { DownloadListComponent } from './download-list/download-list.component';
import { DownloadRequestComponent } from './download-request/download-request.component';
import { CoreModule } from '../../core/core.module';
import { DownloadService } from './download.service';

@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule,
    CalendarModule,
    CheckboxModule,
    AutoCompleteModule,
    NgbModule,
    GrowlModule,
    CoreModule,
    TableModule
  ],
  declarations: [
    DownloadListComponent,
    DownloadRequestComponent
  ],
  providers: [
    DownloadService
  ]
})
export class DownloadModule {}



// WEBPACK FOOTER //
// /opt/app/src/app/features/download/download.module.ts